export const STATUS_SUCCESS = 'success'
export const STATUS_INFO = 'info'
export const STATUS_WARNING = 'warning'
export const STATUS_ERROR = 'error'
